import React from 'react';
import { computed, toJS, action, makeAutoObservable } from 'mobx';
import { observer } from 'src/utils/mobx-react';
import { FormInputState, FormModel } from 'src_common/common/mobx-utils/Form';
import { WithdrawalPendingRowState } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/Pending/WithdrawalPendingRow/WithdrawalPendingRow.state';
import { DROPDOWN_REJECT_OPTIONS } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/SelectionOptions';
import {
    RejectFormWrapper,
    SelectWrapper,
    ButtonWrapper,
} from 'src/components/FraudAndCompliance/AutomaticWithdrawals/Pending/FormReject/FormReject.style';
import { SelectMultiple } from 'src/components/FormComponents/SelectMultiple/SelectMultiple';

interface FormRejectPropsType {
    state: WithdrawalPendingRowState;
}

class State {
    private readonly withdrawalPendingRowState: WithdrawalPendingRowState;

    public readonly reasonReject: FormInputState<Array<string>>;
    public readonly reasonRejectModel: FormModel<Array<string>>;
    public readonly reasonRejectOptions: Record<string, string>;

    public constructor(withdrawalPendingRowState: WithdrawalPendingRowState) {
        this.withdrawalPendingRowState = withdrawalPendingRowState;

        this.reasonReject = new FormInputState([], false);
        this.reasonRejectModel = this.reasonReject.toModel();
        this.reasonRejectOptions = DROPDOWN_REJECT_OPTIONS;
        makeAutoObservable(this);
    }

    @computed public get isDisabled(): boolean {
        return this.reasonReject.value.length === 0 ? true : false;
    }

    @action public onSubmit = async (): Promise<void> => {
        const reasonReject = toJS(this.reasonReject.value);
        await this.withdrawalPendingRowState.onSetRule({
            ruleType: 'reject',
            amount: null,
            reason: reasonReject,
        });
    };
}

export const FormReject = observer('FormReject', (props: FormRejectPropsType): React.ReactElement => {
    const { state: withdrawalPendingRowState } = props;
    const [state] = React.useState(() => new State(withdrawalPendingRowState));

    return (
        <RejectFormWrapper>
            <SelectWrapper data-test='reject-dropdown'>
                <SelectMultiple
                    name='reason'
                    placeholder='Please select...'
                    minSelections={0}
                    maxSelections={9}
                    state={state.reasonReject}
                    model={state.reasonRejectModel}
                    options={state.reasonRejectOptions}
                    viewType='small'
                />
            </SelectWrapper>
            <ButtonWrapper
                btnColor='reject'
                onClick={state.onSubmit}
                isDisabled={state.isDisabled}
                dataTest='reject-button'
            >
                Reject
            </ButtonWrapper>
        </RejectFormWrapper>
    );
});
